module.exports = __webpack_public_path__ + "static/media/start-screen-hero-images.333bccb3.png";